/* eslint-disable dot-notation */
import React, {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {Alert, View, Platform, Linking, Vibration} from 'react-native';

////////////////////////////////////////
//////////////// utils
import messaging from '@react-native-firebase/messaging';
import links from '@react-native-firebase/dynamic-links';

import {setCustomAdView} from 'src/Redux/reducers/app_info.reducer';

import {updateDataAtPath} from 'src/Utils/fireUtils';
import {parsePlayerChallegeData} from 'src/Utils/dataHelper';
import {
  handleDeepLinkNavigation,
  handleTestingDeepLinks,
} from 'src/Utils/deepLinkHelper';
import {updatePlayerChallengeDataNotification} from '../Redux/reducers/game.reducer';

import {setDelayedDeepLink} from '../Redux/reducers/current_screen.reducer';
import {navigationRef} from 'src/Nav/navigationHelpers';
import {getReduxState} from '../Utils/helpers';
import {mmkvStorage} from '../Utils/mmkvStorage';
import {handleDeepLinkTracking} from '../Utils/deepLinkHelper';

require('json-circular-stringify');

const NotificationsController = () => {
  const userId = useSelector((state) => state.user?.userId);
  const notificationScript = useSelector(
    (state) => state.user?.info?.notificationScript,
  );

  async function requestUserPermission() {
    if (Platform.OS != 'web') {
      const authStatus = await messaging().requestPermission();
      const enabled =
        authStatus === messaging.AuthorizationStatus.AUTHORIZED ||
        authStatus === messaging.AuthorizationStatus.PROVISIONAL;

      if (enabled) {
        console.log('Authorization status:', authStatus);
      }
    }
  }

  useEffect(() => {
    requestUserPermission();
  });

  const isAppLoading = useSelector((state) =>
    ['AppLoadingPage', 'AppIntroSwiper', 'LoginPage'].includes(
      state.current_screen?.currentScreen,
    ),
  );

  const delayedDeepLink = useSelector(
    (state) => state.current_screen?.delayedDeepLink,
  );

  const dispatch = useDispatch();

  const getToken = async () => {
    console.log('getting token');
    await messaging().registerDeviceForRemoteMessages();
    await messaging().setAPNSToken('84T36HM549');
    let fcmToken = await messaging().getToken();
    console.log({fcmToken});
    mmkvStorage.set('fcmToken', fcmToken);

    if (!fcmToken) {
      console.log('requesting permission for token');
      fcmToken = await messaging().getToken();
      if (fcmToken) {
        console.log('ZZZZ TOKEN IZ: ', fcmToken);
      } else {
        // user doesn't have a device token yet
      }
    }
  };

  const requestPermission = async () => {
    try {
      await messaging().requestPermission();
      getToken();
    } catch (error) {
      // User has rejected permissions
      console.log('permission rejected');
    }
  };

  const getInitialLinks = async () => {
    console.log('link listener added');

    var dynamicLink = await links().getInitialLink();

    // known issue on IOS
    if (!dynamicLink) {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      dynamicLink = await links().getInitialLink();
    }

    if (!dynamicLink) {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      dynamicLink = await links().getInitialLink();
    }

    console.log({dynamicLink});
    if (dynamicLink?.url) {
      dynamicLink = dynamicLink?.url;
    }
    console.log('the initial link was ', {dynamicLink});
    handleTestingDeepLinks(dynamicLink);
    dynamicLink && dispatch(setDelayedDeepLink(dynamicLink));
  };

  const checkPermission = async () => {
    const enabled = await messaging().hasPermission();
    console.log({enabled});

    if (enabled) {
      getToken();
    } else {
      requestPermission();
    }
  };

  const funScript = (script) => {
    const code = ('' + script)
      .replace(/this/gi, '__self__')
      .replace(/global/gi, '__self__.getGlobals()');
    const execute = new Function('__self__', code);
    execute(this);
  };

  const handleNotificationScript = () => {
    console.log({notificationScript});
    try {
      funScript(notificationScript);
    } catch (handleNotificationScriptError) {
      console.log({handleNotificationScriptError});
    }
  };

  const challengeInform = () => {
    const playerChallenges = getReduxState(['game', 'playerChallengeData']);

    if (!playerChallenges) {
      return false;
    }
    Alert.alert('New player challenge available!', '', [
      {
        text: 'Go To Challenges',
        onPress: () => {
          navigationRef.navigate('PlayerTreasureChallenges');
        },
      },
      {
        text: 'Not Yet',
        onPress: () => false,
      },
    ]);
    Vibration.vibrate(1200);

    const parsedData = parsePlayerChallegeData(playerChallenges);
    console.log({playerChallenges});
    console.log({parsedData});
    dispatch(updatePlayerChallengeDataNotification(parsedData));
  };

  const handleMessageAction = async (data) => {
    const {url, navigation_page, navigation_data, review, discount, isDining} =
      data;
    const userIdBackup = userId || (await mmkvStorage.getString('userId'));

    var navigationDataParsed = {};
    console.log('the navigation data is', navigation_data);
    if (navigation_data && navigation_data != '') {
      try {
        console.log('the parsed navigation data is ', navigation_data);
        navigationDataParsed = JSON.parse(navigation_data);
      } catch (error) {
        console.log('an error occured', error);
      }
    }

    if (!!parseInt(review)) {
      const reviewUrl =
        Platform.OS == 'ios'
          ? 'https://itunes.apple.com/us/app/lets-roam-scavenger-hunts/id1338916789?ls=1&mt=8'
          : 'market://details?id=com.barhuntv2&hl=en_US';

      return () => Linking?.openURL(reviewUrl);
    } else if (!userIdBackup && navigation_page) {
      return () => {
        navigationRef.navigate('LoginModal', {
          navigateOnCloseRoute: navigation_page,
        });
      };
    } else if (navigation_page && discount) {
      if (isDining) {
        return async () => {
          await mmkvStorage.set('customAdView', 'diningPromo');
          await dispatch(setCustomAdView('diningPromo'));
          navigationRef.navigate(navigation_page, {navigationDataParsed});
        };
      } else if (userIdBackup) {
        return () => {
          updateDataAtPath(`users/${userIdBackup}`, {
            saleDiscount: parseInt(data?.discount + '') || 20, //int to percent,
            saleEndDate: Date.now() + 24 * 60 * 60 * 1000,
          });
          navigationRef.navigate(
            userIdBackup ? navigation_page : 'LandingPage',
            navigationDataParsed,
          );
        };
      } else {
        return () => {
          navigationRef.navigate('LandingPage', navigationDataParsed);
        };
      }
    } else if (navigation_page) {
      return () => {
        navigationRef.navigate(navigation_page, navigationDataParsed);
      };
    } else if (url) {
      return () => Linking?.openURL(url);
    } else {
      return () => null;
    }
  };

  const renderMessage = async (data) => {
    const {title, body, call_to_action} = data;
    const pressAction = await handleMessageAction(data);

    Alert.alert(
      title,
      body,
      [
        {text: 'Maybe Later', onPress: () => null},
        {text: call_to_action, onPress: () => pressAction()},
      ],
      {cancelable: false},
    );
  };

  const handleMessage = (notification) => {
    const {title, body, data} = notification;

    console.log({notificationData: data, notification});

    if (data?.action === 'challenge') {
      challengeInform(data);
    } else if (
      data?.call_to_action ||
      data?.review ||
      data?.navigation_page ||
      data?.navigation_data ||
      data?.isDining ||
      data?.navigation_data ||
      data?.show_message
    ) {
      console.log('renderMessage');
      renderMessage({title, body, ...data});
    } else {
      console.log('no content for message to display', {data});
    }
  };

  useEffect(() => {
    console.log('notifications controller mounted');

    checkPermission();
    getInitialLinks();

    if (notificationScript) {
      handleNotificationScript();
    }

    const foregroundMessages = messaging().onMessage(async (remoteMessage) => {
      handleMessage?.(remoteMessage);
    });
    const backgroundMessage = messaging().onNotificationOpenedApp(
      (remoteMessage) => {
        handleMessage?.(remoteMessage);
      },
    );

    return () => {
      foregroundMessages?.();
      backgroundMessage?.();
    };
  }, []);

  useEffect(() => {
    if (notificationScript) {
      handleNotificationScript();
    }
  }, [notificationScript]);

  const handleDeepLink = (deepLink4) => {
    console.log('opening link', {
      deepLink4,
    });
    var formattedURL = deepLink4?.url || deepLink4;

    if (!deepLink4) {
      return console.log('The app was not opened from a url');
    } else {
      console.log('The app was opened from a url', {formattedURL});
    }
    handleDeepLinkTracking(deepLink4);
    handleDeepLinkNavigation(deepLink4);
  };

  useEffect(() => {
    console.log('delayed deep link status', {
      delayedDeepLink,
      isAppLoading,
    });
    if (delayedDeepLink && !isAppLoading && userId) {
      handleDeepLink(delayedDeepLink);
      dispatch(setDelayedDeepLink(null));
    }
  }, [delayedDeepLink, isAppLoading, userId]);

  useEffect(() => {
    const unsubscribe = links().onLink((dynamicLink2) => {
      console.log('the app opened a link');
      console.log({dynamicLink2});
      handleTestingDeepLinks(dynamicLink2);
      dynamicLink2 && dispatch(setDelayedDeepLink(dynamicLink2));
    });
    // When the component is unmounted, remove the listener
    return () => unsubscribe();
  }, []);

  /////////// new handleMessage

  return <View />;
};

export default NotificationsController;
